<template>
  <div class="w-full">
    <vs-table
      maxHeight="68vh"
      noDataText=""
      search
      pagination
      max-items="10"
      :data="cidades"
    >
      <template slot="header">
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <h4 style="color: #b4aa99">cidades</h4>
          </vs-col>
          <vs-col vs-w="6">
            <ModalCadastroCidade @update="getCidades" />
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th sort-key="nome">Cidades</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="tr.lixeira == 1 ? 'danger' : ''"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="tr.nome">{{ tr.nome }}</vs-td>
          <vs-td class="actions">
            <ModalEditarCidade :cidade="tr" @update="getCidades" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="cidades.length == 0">
      <div class="con-colors">
        <ul>
          <li class="danger-box">
            <h2 class="p-5" style="color: white !important">
              Nenhuma cidade cadstrada
            </h2>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCadastroCidade from "./cadastro.vue"
import ModalEditarCidade from "./editar.vue"

export default {
  data () {
    return {
      cidades: []
    }
  },
  methods: {
    async getCidades () {
      this.$vs.loading()
      try {
        this.cidades = await this.$http.get(`cidade`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  components: {
    ModalCadastroCidade,
    ModalEditarCidade
  },
  mounted () {
    this.getCidades()
  }
};
</script>

<style>
.col {
  width: auto;
}
.actions {
  width: 60px !important;
}
</style>
